export default function PesquisarCliente (){
    return (
        "Pesquisar Cliente"
    );
}